import { notifications } from '@mantine/notifications';
import { IconCheck, IconX } from '@tabler/icons-react';

export const mutationNotif = {
  loading: (
    id: string,
    { title, message }: { title: string; message: string },
  ) =>
    notifications.show({
      id,
      loading: true,
      title,
      message,
      autoClose: false,
      withCloseButton: false,
    }),
  toSuccess: (id: string, message: string) => {
    notifications.update({
      id,
      loading: false,
      message,
      color: 'teal',
      icon: <IconCheck size={18} />,
      autoClose: 3000,
    });
  },
  toError: (id: string, message: string) =>
    notifications.update({
      id,
      loading: false,
      message,
      color: 'red',
      icon: <IconX size={18} />,
      autoClose: 3000,
    }),
};
